import { useState, useEffect } from 'react';

const EyeOpen = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></svg>
);
const EyeClosed = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M17.94 17.94A10.07 10.07 0 0112 20c-7 0-11-8-11-8a18.45 18.45 0 015.06-5.94M9.9 4.24A9.12 9.12 0 0112 4c7 0 11 8 11 8a18.5 18.5 0 01-2.16 3.19m-6.72-1.07a3 3 0 11-4.24-4.24"/><line x1="1" y1="1" x2="23" y2="23"/></svg>
);

function Config({ token, appName, onAppNameChange }) {
  const [config, setConfig] = useState({ apiKey: '', projectId: '' });
  const [localAppName, setLocalAppName] = useState(appName || '');
  const [showFields, setShowFields] = useState({});
  const [configured, setConfigured] = useState(false);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [savingName, setSavingName] = useState(false);
  const [message, setMessage] = useState('');
  const [nameMessage, setNameMessage] = useState('');

  useEffect(() => { fetchConfig(); }, []);

  const fetchConfig = async () => {
    try {
      const resp = await fetch('/api/config', { headers: { Authorization: `Bearer ${token}` } });
      const data = await resp.json();
      if (resp.ok) {
        setConfig({ apiKey: data.apiKeyRaw || '', projectId: data.projectIdRaw || '' });
        setConfigured(data.configured);
        if (data.appName) setLocalAppName(data.appName);
      }
    } catch (err) {
      console.error('Error cargando configuracion:', err);
    } finally {
      setLoading(false);
    }
  };

  const handleSave = async (e) => {
    e.preventDefault();
    setSaving(true);
    setMessage('');
    try {
      const resp = await fetch('/api/config', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
        body: JSON.stringify(config)
      });
      const data = await resp.json();
      if (!resp.ok) throw new Error(data.error);
      setMessage('Configuracion guardada correctamente.');
      setConfigured(true);
    } catch (err) {
      setMessage(`Error: ${err.message}`);
    } finally {
      setSaving(false);
    }
  };

  const handleSaveAppName = async (e) => {
    e.preventDefault();
    setSavingName(true);
    setNameMessage('');
    try {
      const resp = await fetch('/api/config', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
        body: JSON.stringify({ ...config, appName: localAppName })
      });
      const data = await resp.json();
      if (!resp.ok) throw new Error(data.error);
      setNameMessage('Nombre actualizado.');
      onAppNameChange(localAppName);
    } catch (err) {
      setNameMessage(`Error: ${err.message}`);
    } finally {
      setSavingName(false);
    }
  };

  if (loading) {
    return <div className="config-page"><div className="spinner" style={{ margin: '3rem auto' }}></div></div>;
  }

  return (
    <div className="config-page">
      <h2 className="config-page-title">Configuracion</h2>
      <p className="config-page-subtitle">Administra las credenciales de IBM WatsonX</p>

      <div className="config-card app-name-card">
        <div className="config-header">
          <div className="config-icon" style={{ background: '#1a1a2e' }}>
            <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2">
              <path d="M12 20h9"/><path d="M16.5 3.5a2.121 2.121 0 013 3L7 19l-4 1 1-4L16.5 3.5z"/>
            </svg>
          </div>
          <div>
            <h2>Nombre de la aplicacion</h2>
            <p className="config-subtitle">Personaliza el nombre visible</p>
          </div>
        </div>
        <form onSubmit={handleSaveAppName} className="app-name-form">
          <div className="input-wrapper">
            <input type="text" value={localAppName} onChange={e => setLocalAppName(e.target.value)}
              placeholder="Nombre de la aplicacion" required />
          </div>
          {nameMessage && <div className={`config-message ${nameMessage.startsWith('Error') ? 'error' : 'success'}`}>{nameMessage}</div>}
          <button type="submit" className="btn btn-primary config-save-btn" disabled={savingName}>
            {savingName ? 'Guardando...' : 'Guardar'}
          </button>
        </form>
      </div>

      <div className="config-card active-provider">
        <div className="config-header">
          <div className="config-icon" style={{ background: '#4361ee' }}>
            <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2">
              <circle cx="12" cy="12" r="3"/><path d="M19.4 15a1.65 1.65 0 00.33 1.82l.06.06a2 2 0 010 2.83 2 2 0 01-2.83 0l-.06-.06a1.65 1.65 0 00-1.82-.33 1.65 1.65 0 00-1 1.51V21a2 2 0 01-4 0v-.09A1.65 1.65 0 009 19.4a1.65 1.65 0 00-1.82.33l-.06.06a2 2 0 01-2.83-2.83l.06-.06A1.65 1.65 0 004.68 15a1.65 1.65 0 00-1.51-1H3a2 2 0 010-4h.09A1.65 1.65 0 004.6 9a1.65 1.65 0 00-.33-1.82l-.06-.06a2 2 0 012.83-2.83l.06.06A1.65 1.65 0 009 4.68a1.65 1.65 0 001-1.51V3a2 2 0 014 0v.09a1.65 1.65 0 001 1.51 1.65 1.65 0 001.82-.33l.06-.06a2 2 0 012.83 2.83l-.06.06A1.65 1.65 0 0019.4 9a1.65 1.65 0 001.51 1H21a2 2 0 010 4h-.09a1.65 1.65 0 00-1.51 1z"/>
            </svg>
          </div>
          <div>
            <h2>IBM WatsonX / Granite AI</h2>
            <p className="config-subtitle">Granite 3.3 8B Instruct + Watson STT</p>
          </div>
        </div>

        <div className={`config-badge ${configured ? 'configured' : 'not-configured'}`}>
          {configured ? 'Configurado' : 'No configurado'}
        </div>

        <form onSubmit={handleSave}>
          <div className="config-field">
            <label>API KEY</label>
            <div className="input-wrapper">
              <input type={showFields.apiKey ? 'text' : 'password'} value={config.apiKey}
                onChange={e => setConfig({ ...config, apiKey: e.target.value })}
                placeholder="IBM Cloud API Key" required />
              <button type="button" className="toggle-visibility" onClick={() => setShowFields(p => ({ ...p, apiKey: !p.apiKey }))}>
                {showFields.apiKey ? <EyeClosed /> : <EyeOpen />}
              </button>
            </div>
          </div>
          <div className="config-field">
            <label>PROJECT ID</label>
            <div className="input-wrapper">
              <input type={showFields.projectId ? 'text' : 'password'} value={config.projectId}
                onChange={e => setConfig({ ...config, projectId: e.target.value })}
                placeholder="WatsonX Project ID" required />
              <button type="button" className="toggle-visibility" onClick={() => setShowFields(p => ({ ...p, projectId: !p.projectId }))}>
                {showFields.projectId ? <EyeClosed /> : <EyeOpen />}
              </button>
            </div>
          </div>
          {message && <div className={`config-message ${message.startsWith('Error') ? 'error' : 'success'}`}>{message}</div>}
          <button type="submit" className="btn btn-primary config-save-btn" disabled={saving}>
            {saving ? 'Guardando...' : 'Guardar Configuracion'}
          </button>
        </form>
      </div>
    </div>
  );
}

export default Config;
